import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../../../environments/environment";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private settingSmtpUrl = environment.apiUrl + "admin/setting/smtp";
  private settingSmsUrl = environment.apiUrl + "admin/setting/sms";
  private settingCPUrl = environment.apiUrl + "admin/setting/change-password";
  private settingPushNotificationUrl = environment.apiUrl + "admin/setting/push-notification";
  private settingGeneralUrl = environment.apiUrl + "admin/setting/general";
  private notificationUrl = environment.apiUrl + "admin/divers/notification-list";
  private notificationAdminUrl = environment.apiUrl + "admin/setting/notificationadminlist";
  private notificationountUrl = environment.apiUrl + "admin/setting/notific-count";
  private settingDeleteUrl = environment.apiUrl + "admin/setting";
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();

  constructor(
    private http: HttpClient
  ) { }
  
  notifyOther(data: any){
    if(data) {
      this.notify.next(data);
    }
  }

  getSmtpSettingDetail() {
    return this.http.get(this.settingSmtpUrl, {
      headers: new HttpHeaders(),
    });
  }

  editSmtpSetting(data: any) {
    console.log('data', data);
    return this.http.post(this.settingSmtpUrl, data, {
      headers: new HttpHeaders 
    });
  }

  getSmsSettingDetail() {
    return this.http.get(this.settingSmsUrl, {
      headers: new HttpHeaders(),
    });
  }

  editSmsSetting(data: any) {
    return this.http.post(this.settingSmsUrl, data, {
      headers: new HttpHeaders 
    });
  }

  changePassword(data: any) {
    return this.http.post(this.settingCPUrl, data, {
      headers: new HttpHeaders 
    });
  }

  getPushNotificationSettingDetail() {
    return this.http.get(this.settingPushNotificationUrl, {
      headers: new HttpHeaders(),
    });
  }

  editPushNotificationSetting(data: any) {
    return this.http.post(this.settingPushNotificationUrl, data, {
      headers: new HttpHeaders 
    });
  }

  getGeneralSettingDetail() {
    return this.http.get(this.settingGeneralUrl, {
      headers: new HttpHeaders(),
    });
  }

  editGeneralSetting(data: any) {
    return this.http.post(this.settingGeneralUrl, data, {
      headers: new HttpHeaders 
    });
  }

  getNotificationDetail() {
    return this.http.get(this.notificationUrl, {
      headers: new HttpHeaders(),
    });
  }
 
  getNotificationAdminDetail(data: any) {
    return this.http.post(this.notificationAdminUrl, data,{
      headers: new HttpHeaders
    });
  }

  getNotificationCount() {
    return this.http.get(this.notificationountUrl, {
      headers: new HttpHeaders(), 
    });
  }

  deleteNotification(data: any) {
    return this.http.delete(this.settingDeleteUrl, {
      headers: new HttpHeaders(), params: data
    });
  }

  updateNotification(data: any) {
    return this.http.put(this.settingDeleteUrl, data, {
      headers: new HttpHeaders
    });
  }

}

